<template>
  <div>
    <!-- <ClockStuckedCard></ClockStuckedCard> -->
    <!-- <ClockListEmptyCard></ClockListEmptyCard> -->
    <WaitingBlock v-if="isLoadingClocks || isLoadingBoxes"></WaitingBlock>
    <ClockStuckedCard
      v-else-if="(clockList==null || clockList.count==0) && (boxList == null || boxList.count==0) "
    ></ClockStuckedCard>
    <ClockListEmptyCard v-else-if="(clockList==null || clockList.count==0)"></ClockListEmptyCard>
    <b-list-group v-else class="list-cards">
      <ItemListCard
        v-for="clock in clockList.items"
        :key="clock.uid"
        :item="clock"
        @click.native.stop="goToClock(clock)"
      >
        <template slot="Content"></template>
        <template slot="QuickStats">
          <div class="stat-item">
            <span class="stats-value">{{clock.statistics.boxCount}}</span>
                <i class="far fa-dot-circle" v-tooltip="{data: 'Total Box Count'}"></i>
          </div>

          <div class="stat-item">
            <span class="stats-value">{{clock.statistics.musicBoxCount}}</span>
                <i class="fas fa-box-open" v-tooltip="{ data: 'Distinct Music Box Count'}"></i>
          </div>

          <div class="stat-item">
            <span class="stats-value">{{clock.statistics.smartBoxCount}}</span>
                <i class="fas fa-bolt" v-tooltip="{ data: 'Distinct Smart Box Count'}"></i>
          </div>

          <div class="stat-item">
            <span class="stats-value">{{clock.statistics.jingleBoxCount}}</span>
                <i class="fas fa-music" v-tooltip="{ data: 'Distinct Jingle Box Count'}"></i>
          </div>

          <div class="stat-item">
            <span class="stats-value">
              {{Math.round(clock.statistics.averageMood * 10) / 10}}
              <small>/3</small>
            </span>
                <i class="far fa-grin" v-tooltip="{ data: 'Average Mood'}"></i>
          </div>

          <div class="stat-item">
            <span class="stats-value">
              {{Math.round(clock.statistics.averageEnergy * 10) / 10}}
              <small>/5</small>
            </span>
                <i class="fas fa-battery-half" v-tooltip="{ data: 'Average Energy'}"></i>
          </div>
        </template>
        <template slot="Menu">
          <b-dropdown no-caret>
            <template slot="button-content">
              <i class="fas fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item v-on:click.stop="startEditClock(clock.uid)">Settings...</b-dropdown-item>
            <b-dropdown-item @click.stop="$router.push({ name: 'ClockStats', params: { stationUid: currentStationUid, clockUid: clock.uid } })">Show stats</b-dropdown-item>
            <b-dropdown-item v-on:click.stop="startDuplicateClock(clock.uid)">Duplicate</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item v-on:click.stop="startDeleteClock(clock)">Delete clock</b-dropdown-item>
          </b-dropdown>
        </template>
      </ItemListCard>
    </b-list-group>
    <ClockRemovalCard
      ref="modalRemoval"
      v-show="viewState.showDeleteConfirmation"
      v-on:clockDeleted="clockDeleted"
      :stationUid="currentStationUid"
      :clock="currentClock"
      :displayData="true"
    />
  </div>
</template>

<script>
import store from "@/store";
import Portlet from "@/components/common/Portlet.vue";
import WaitingBlock from "@/components/common/WaitingBlock.vue";
import ItemListCard from "@/components/common/PlannerItemListCard.vue";
import ClockStuckedCard from "./ClockStuckedCard.vue";
import ClockListEmptyCard from "./ClockListEmptyCard.vue";
import ClockRemovalCard from "./ClockRemovalCard.vue";
import { mapState, mapMutations, mapActions } from "vuex";
import EventBus from "@/eventbus";
import Tooltip from "@/components/common/Tooltip.vue";

export default {
  name: "ClockIndex",
  store,
  components: {
    Portlet,
    WaitingBlock,
    ClockStuckedCard,
    ClockListEmptyCard,
    ItemListCard,
    ClockRemovalCard,
    Tooltip
  },
  computed: {
    ...mapState({
      isLoadingClocks: function() {
        return store.state.loadingStates.isLoadingStationClocks;
      },
      isLoadingBoxes: function() {
        return store.state.loadingStates.isLoadingStationBoxes;
      },
      clockList: function() {
        return store.state.stationClocks;
      },
      boxList: function() {
        return store.state.stationBoxes;
      },
      currentStationUid: function() {
        return store.state.currentStationUid;
      }
    })
  },
  mounted() {
    const { stationUid } = this.$route.params;
    this.$store.dispatch('loadStationClocks', stationUid);
  },
  data() {
    return {
      viewState: {
        showDeleteConfirmation: false
      },
      currentClock: null
    };
  },
  methods: {
    async clockDeleted() {
      await this.$store.dispatch(
        "loadStationClocks",
        this.$store.state.currentStationUid
      );
    },
    startDeleteClock(clock) {
      this.viewState.showDeleteConfirmation = true;
      this.currentClock = clock;
      this.$refs.modalRemoval.show();
    },
    startDuplicateClock(uid) {
      EventBus.$emit("onClockDuplicate", uid);
    },
    startEditClock(uid) {
      EventBus.$emit("onClockEdition", uid);
    },
    onClick(clock) {
      this.activateClock(clock);
    },
    goToClock(clock){
      this.$router.push({
        name:'ClockDetails',
        params:{
          clockUid: clock.uid
        }
      })
    }
  }
};
</script>

<style scoped>
</style>
